module.exports = __webpack_public_path__ + "img/logo.0e2e0981.svg";